import React from "react";
import { Link, useNavigate, useLocation, NavLink } from 'react-router-dom';
import { Col, Row, Card, Container, Breadcrumb, Table, Badge } from 'react-bootstrap';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import bclogo from "../../assets/images/logogf.png";
import '../../assets/css/client.css';
import {
    FiLogOut
} from 'react-icons/fi';
import {
    IoPersonOutline,
    IoTicketOutline,
    IoHelpCircleOutline
} from 'react-icons/io5';
import { Button } from 'primereact/button';
import { GoHome } from "react-icons/go";
import { GrServices } from "react-icons/gr";
import { TbUserScan } from "react-icons/tb";

/*------------Card Icon------------*/

import { LiaTasksSolid } from "react-icons/lia";
import { GrInProgress } from "react-icons/gr";
import { MdPublishedWithChanges } from "react-icons/md";
import { TbCalendarDue } from "react-icons/tb";
import { MdOutlineConnectWithoutContact } from "react-icons/md";

import { Avatar } from 'primereact/avatar';
import { Tooltip } from 'primereact/tooltip';
import { useClientAuth } from '../../context/ClientAuthContext';
import { replayOnboardingTour } from '../../components/onboarding/onboardingStorage';
const Client_navbar = () => {
    const { isAuthenticated, role, logout, username, userId, accessToken } = useClientAuth();
    const navigate = useNavigate();
    const location = useLocation();


    const getCheckInClass = (checkedIn) => {
        return checkedIn ? 'bg-success' : 'bg-secondary';
    };

    const handleLogout = () => {
        logout();
        navigate('/Client/login');
    };

    const handleReplayOnboarding = () => {
        // Route to the right tour based on where the client currently is - the "?" icon
        // is shared across all client pages, so it can't just always replay the Home tour.
        // Each namespace here must match the `namespace` prop on that page's own
        // `OnboardingTour` mount (Client_profile.js, Onboarding_Form.js, or the
        // Client_dashboard.js shell for everything else).
        if (location.pathname.includes('Client_profile')) {
            replayOnboardingTour('client-profile');
        } else if (location.pathname.includes('Onboarding_Form')) {
            replayOnboardingTour('client-onboarding-form');
        } else {
            replayOnboardingTour('client');
        }
    };

    return (
        <div id="header">
            <div className='topheader clientHeader'>
                <div className='position-relative' data-onboarding="client-logo">
                    <div className="logotext border-0">
                        <p>
                            <img
                                src={require("../../assets/images/logogf.png")}
                                alt="Logo"
                                style={{ width: '30px', height: '30px', marginRight: '10px' }}
                            />
                            BlackBox
                        </p>
                    </div>
                </div>
                <div>
                    <ul>
                        {/* <li>
                            <NavLink
                                to="/Client/dashboard/Client_dash"
                                activeClassName="active"
                                className="nav-link"
                            >
                                Dashboard
                            </NavLink>
                        </li> */}
                        <li data-onboarding="client-nav-onboarding">
                            <NavLink
                                to="/Client/dashboard/Client_home"
                                activeClassName="active"
                                className="nav-link"
                            >
                                OnBoarding
                            </NavLink>
                        </li>

                        <li data-onboarding="client-nav-profile">
                            <NavLink
                                to="/Client/dashboard/Client_profile"
                                activeClassName="active"
                                className="nav-link"
                            >
                                My Profile
                            </NavLink>
                        </li> 
                        <li style={{ display: 'flex', alignItems: 'center' }}>
                            <span
                                className="client-help-icon"
                                role="button"
                                tabIndex={0}
                                aria-label="Onboarding Steps"
                                data-pr-tooltip="Onboarding Steps"
                                data-pr-position="bottom"
                                onClick={handleReplayOnboarding}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') handleReplayOnboarding();
                                }}
                            >
                                <IoHelpCircleOutline />
                            </span>
                            <Tooltip target=".client-help-icon" />

                            <div data-onboarding="client-user-menu">
                                <DropdownButton
                                    className='userdrop'
                                    id="dropdown-basic-button"
                                    title={
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <img
                                                src={require("../../assets/images/client-default.png")}
                                                alt="User"
                                                style={{ width: '32px', height: '32px', marginRight: '10px' }}
                                            />
                                            <small className={getCheckInClass(isAuthenticated)}></small>

                                        </div>
                                    }
                                >
                                    
                                    <Dropdown.Item disabled className="p-0">
                                       <p className="drop_username mb-0">{username}</p>
                                    </Dropdown.Item>
                                    {/* <Dropdown.Item as={NavLink} to="/Client/dashboard/Client_profile">
                                        <IoPersonOutline /> My Profile
                                    </Dropdown.Item> */}
                                    {/* <Dropdown.Item as={NavLink} to="/raise-ticket">
                                        <IoTicketOutline /> Raise Ticket
                                    </Dropdown.Item> */}
                                    <Dropdown.Item tag={Link} onClick={handleLogout}>
                                        <FiLogOut /> Logout
                                    </Dropdown.Item>
                                </DropdownButton>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            {/* ----------- mobile menu ---------- */}

            <div className="mobile-menu_footer d-lg-none d-block">
                <ul>
                    {/* <li>
                        <NavLink
                            to="/Client/dashboard/Client_home"
                            activeClassName="active"
                            className="nav-link"
                        >
                            <span className="d-block"><GoHome /></span>
                            Dashboard
                        </NavLink>
                    </li> */}
                    <li>
                        <NavLink
                            to="/Client/dashboard/Client_home"
                            activeClassName="active"
                            className="nav-link"
                        >
                            <span className="d-block"><GrServices /></span>
                            OnBoarding
                        </NavLink>
                    </li>

                    <li>
                        <NavLink
                            to="/Client/dashboard/Client_profile"
                            activeClassName="active"
                            className="nav-link"
                        >
                             <span className="d-block"><TbUserScan /></span>
                            My Profile
                        </NavLink>
                    </li> 
                </ul>
            </div>
        </div>

    )
}

export default Client_navbar
